import React from "react";
import PropTypes from "prop-types";
import "./StepIndicator.css";

const StepIndicator = ({ currentStep, className, ...rest }) => {
  const steps = [1, 2, 3];

  const getStepStatus = (step) => {
    if (step < currentStep) return "done";
    if (step === currentStep) return "current";
    return "todo";
  };

  const getLineStatus = (fromStep) => {
    return fromStep < currentStep ? "done" : "todo";
  };

  return (
    <div
      className={`mx-auto flex justify-center step-indicator text-center ${className || ""}`}
      {...rest}
    >
      {steps.map((step, idx) => (
        <React.Fragment key={step}>
          <div className={`step-dot ${getStepStatus(step)}`} />
          {idx < steps.length - 1 && (
            <div className={`step-line ${getLineStatus(step)}`} />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

StepIndicator.propTypes = {
  currentStep: PropTypes.number.isRequired,
};

export default StepIndicator;
